/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 로그인 페이지
 * 버전 : 1.0
 * 파일명 : LoginPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-10, 강동형 : 저작권 추가, 구조개선
 * 수정 : 2025-07-14, 강동형 : DefferdPrompt 전역변수로 변경
 * ================================================================*/

import { useEffect, useState } from 'react';
import InstallGuideTap from './InstallGuideTap';
import LoginTap from './LoginTap';
import { usePwaStore } from 'src/stores/UIStore';

export type LoginPageTabType = "Login" | "InstallGuide"

const LoginPage = () => {
  const [tab,setTab] = useState<LoginPageTabType>('Login')
  const setDeferredPrompt = usePwaStore((state)=>state.setDeferredPrompt)
  const setWhichDevice = usePwaStore((state)=>state.setWhichDevice)
  const setIsInsatalled = usePwaStore((state)=>state.setIsInsatalled)

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault(); // 자동 배너 방지
    setDeferredPrompt(e); // 이후에 사용자 요청으로 트리거
  });

  function getPWADisplayMode() {
    if (window.matchMedia('(display-mode: standalone)').matches)
      return setIsInsatalled(true)
    return setIsInsatalled(false)
  }
  
  const checkDevice = () => { // 접속 기기 감지 함수
    const userAgent = navigator.userAgent || navigator.vendor; 
    if (/android/i.test(userAgent)) {
        setWhichDevice('android')
    }
    else if (/iPad|iPhone|iPod/.test(userAgent)) {
        setWhichDevice('ios')
    }
    else{
        setWhichDevice('etc')
    }
  };

  useEffect(()=>{
    checkDevice()
    getPWADisplayMode()
  },[])

  return (
    <div>
      {tab === 'Login' && <LoginTap setTab={setTab}/>}
      {tab === 'InstallGuide' && <InstallGuideTap setTab={setTab}/>}
    </div>
  );
};

export default LoginPage;